import { useEffect } from "react";
import confetti from "canvas-confetti";
import { Gift } from "lucide-react";
import { useLang } from "@/i18n";

const base = `${process.env.PUBLIC_URL || ""}/game-assets`;

// Celebratory popup shown when a player earns a free character (e.g. La Gigantona
// for beating the Level 3 grandma boss). In-app-browser safe (scrollable overlay).
export default function RewardModal({ charId, charName, onClose }) {
  const { t } = useLang();

  useEffect(() => {
    const colors = ["#E91E63", "#FFEB3B", "#0067C6", "#4CAF50", "#ff3da6"];
    const fire = () => {
      confetti({ particleCount: 70, spread: 90, origin: { x: 0.5, y: 0.4 }, colors });
      confetti({ particleCount: 40, angle: 60, spread: 70, origin: { x: 0, y: 0.6 }, colors });
      confetti({ particleCount: 40, angle: 120, spread: 70, origin: { x: 1, y: 0.6 }, colors });
    };
    fire();
    const iv = setInterval(fire, 1100);
    const stop = setTimeout(() => clearInterval(iv), 4500);
    return () => { clearInterval(iv); clearTimeout(stop); };
  }, []);

  return (
    <div className="fixed inset-0 z-[120] bg-black/85 overflow-y-auto overscroll-contain flex items-start justify-center p-4"
      onClick={onClose} data-testid="reward-modal-overlay">
      <div className="pixel-card bg-[#141414] w-full max-w-sm my-8 max-h-full text-center nb-pop p-5"
        onClick={(e) => e.stopPropagation()} data-testid="reward-modal">
        <p className="font-pixel text-[10px] text-[#FFEB3B] pixel-stroke flex items-center justify-center gap-1.5 mb-2">
          <Gift size={14} strokeWidth={2.5} /> {t("rewardFreeTag")}
        </p>
        <h2 className="font-pixel text-base md:text-xl text-[#E91E63] pixel-stroke leading-tight" data-testid="reward-title">
          {t("rewardUnlockedTitle")(charName)}
        </h2>
        <div className="my-3 flex justify-center">
          <img src={`${base}/${charId}.webp`} alt={charName} draggable={false}
            className="nb-dance" style={{ height: "min(30vh, 190px)", filter: "drop-shadow(0 10px 14px rgba(233,30,99,0.55))" }} />
        </div>
        <p className="font-vt text-lg text-white/90 leading-snug px-2" data-testid="reward-body">
          {t("rewardUnlockedBody")(charName)}
        </p>
        <button data-testid="reward-close-btn" onClick={onClose}
          className="pixel-btn bg-[#4CAF50] text-white w-full px-6 py-3 text-sm mt-4 blink">
          {t("gigantonaRewardCta")}
        </button>
      </div>
    </div>
  );
}
